import { createContext, ReactNode, useCallback, useContext } from 'react';

import { User } from 'entities';

import { useSyncRef } from 'hooks/syncRef';

export interface OpenModalParams {
  onConfirm: (newOwner: User | null, justification: string) => void | Promise<void>;
  cancel?: () => void;
  text: string;
  currentOwner: User;
  allowRemoval?: boolean;
  requireJustification?: boolean;

  buttonText?: ReactNode;
}

interface ChangeOwnerModalContext {
  openChangeOwnerModal: (params: OpenModalParams) => void;
}

export const ownershipChangeCtx = createContext<ChangeOwnerModalContext>(
  {} as ChangeOwnerModalContext,
);

export function useOwnershipChange(): ChangeOwnerModalContext {
  const context = useContext(ownershipChangeCtx);

  if (!context.openChangeOwnerModal) {
    throw new Error('useOwnershipChange must be used within its provider');
  }

  return context;
}

export function useSingleOwnerChange(params: OpenModalParams): () => void {
  const { openChangeOwnerModal } = useOwnershipChange();

  // optimized correctly
  const paramsRef = useSyncRef(params);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(() => openChangeOwnerModal(paramsRef.current), [openChangeOwnerModal]);
}
